<script>
  import { createEventDispatcher } from 'svelte';
  import Conexoes from '../../Classes/Conexoes.js';
  import Constantes from '../../Classes/Constantes.js';
  import { tenantLogado } from '../../Classes/Stores.js';
  import { get } from 'svelte/store';

  const dispatch = createEventDispatcher();
  const conexao = new Conexoes();
  $: tenant = $tenantLogado;
  export let locais = [];

  function isoData(d) {
    const z = n => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}`;
  }
  const hoje = new Date();
  // Se já existem horários abertos, sugere começar no dia seguinte ao último (evita horários duplicados)
  let ultimoExistente = (() => {
    const t = get(tenantLogado);
    if (!t?.ultimo_horario) return null;
    const d = new Date(String(t.ultimo_horario).replace(' ', 'T'));
    return !isNaN(d) && d >= hoje ? d : null;
  })();
  let inicioSugerido = new Date(ultimoExistente || hoje);
  if (ultimoExistente) inicioSugerido.setDate(inicioSugerido.getDate() + 1);
  const daqui60 = new Date(inicioSugerido); daqui60.setDate(daqui60.getDate() + 60);

  // Já vem preenchido com o caso mais comum: próximos 60 dias, segunda a sexta, 08h–18h, almoço 12h–14h, 1h por atendimento
  let dataInicio = isoData(inicioSugerido);
  let dataFim = isoData(daqui60);
  let diasSelecionados = [1, 2, 3, 4, 5];
  let modo = 'expediente'; // 'expediente' | 'avulsos'
  let inicioExpediente = '08:00';
  let fimExpediente = '18:00';
  let duracao = 60;
  let temIntervalo = true;
  let inicioIntervalo = '12:00';
  let fimIntervalo = '14:00';
  let horariosInicio = [{ hora: '' }];
  let localAtendimento = '';
  let novoLocalNome = '';
  let novoLocalEndereco = '';
  let erros = {};

  const diasDaSemana = ['Domingo','Segunda','Terça','Quarta','Quinta','Sexta','Sábado'];
  const duracoes = [15, 20, 30, 40, 45, 50, 60, 90, 120];
  function rotuloDuracao(d) {
    if (d < 60) return `${d} minutos`;
    return { 60: '1 hora', 90: '1 hora e meia', 120: '2 horas' }[d] || `${d} minutos`;
  }

  $: if (locais.length === 1 && !localAtendimento) localAtendimento = `${locais[0].nome}|${locais[0].endereco || ''}`;

  function minutos(hhmm) { const [h, m] = (hhmm || '0:0').split(':').map(Number); return h * 60 + m; }
  function hhmm(min) { return `${String(Math.floor(min / 60)).padStart(2, '0')}:${String(min % 60).padStart(2, '0')}`; }

  $: horariosCalculados = (() => {
    if (modo !== 'expediente' || !inicioExpediente || !fimExpediente || !duracao) return [];
    const lista = [];
    const ini = minutos(inicioExpediente), fim = minutos(fimExpediente);
    const pausaIni = minutos(inicioIntervalo), pausaFim = minutos(fimIntervalo);
    for (let t = ini; t + Number(duracao) <= fim; t += Number(duracao)) {
      const terminaEm = t + Number(duracao);
      if (temIntervalo && t < pausaFim && terminaEm > pausaIni) continue;
      lista.push(hhmm(t));
    }
    return lista;
  })();

  $: listaFinal = modo === 'expediente' ? horariosCalculados : horariosInicio.map(h => h.hora).filter(Boolean);

  // Estimativa do total, para a pessoa saber o que vai ser criado antes de clicar
  $: totalEstimado = (() => {
    if (!dataInicio || !dataFim || dataFim < dataInicio) return 0;
    let dias = 0;
    const d = new Date(dataInicio + 'T00:00:00'), f = new Date(dataFim + 'T00:00:00');
    for (; d <= f; d.setDate(d.getDate() + 1)) if (diasSelecionados.includes(d.getDay())) dias++;
    return dias * listaFinal.length;
  })();

  function handleDiaChange(dia) {
    diasSelecionados = diasSelecionados.includes(dia) ? diasSelecionados.filter(d => d !== dia) : [...diasSelecionados, dia];
  }

  function validar() {
    const e = {};
    if (locais.length === 0 && !novoLocalNome.trim()) e.local = 'Informe onde você atende (ex.: Consultório Centro, Salão, Online).';
    if (locais.length > 0 && !localAtendimento) e.local = 'Escolha onde serão esses atendimentos.';
    if (!dataInicio) e.datas = 'Escolha a data de início.';
    else if (!dataFim) e.datas = 'Escolha até quando os horários ficam abertos.';
    else if (dataFim < dataInicio) e.datas = 'A data final precisa ser igual ou depois da data inicial.';
    if (diasSelecionados.length === 0) e.dias = 'Marque pelo menos um dia da semana.';
    if (modo === 'expediente') {
      if (minutos(fimExpediente) <= minutos(inicioExpediente)) e.horarios = 'O fim do expediente precisa ser depois do início.';
      else if (horariosCalculados.length === 0) e.horarios = 'Com essa duração e esse intervalo não cabe nenhum horário. Ajuste o expediente.';
    } else if (listaFinal.length === 0) {
      e.horarios = 'Informe pelo menos um horário.';
    }
    erros = e;
    return Object.keys(e).length === 0;
  }

  async function criarHorarios() {
    if (!validar()) return;
    dispatch('loading', true);

    let nome, endereco;
    if (locais.length === 0) {
      // Cria o local aqui mesmo, sem obrigar a pessoa a ir em outra tela antes
      nome = novoLocalNome.trim();
      endereco = novoLocalEndereco.trim();
      const urlLocal = Constantes.api_acesso.replace('acesso.php', 'salvar_local.php');
      await conexao.conecta(urlLocal, { body: { id_tenant: tenant.id, nome, endereco, acao: 'salvar' } });
    } else {
      [nome, endereco] = localAtendimento.split('|');
    }

    const res = await conexao.conecta(Constantes.api_criar_horarios, {
      body: {
        id_tenant: tenant.id,
        dataInicio, dataFim, diasSelecionados,
        horariosInicio: listaFinal.map(hora => ({ hora })),
        duracao_minutos: Number(duracao),
        local: nome || 'Padrão',
        endereco: endereco || ''
      }
    });
    dispatch('loading', false);

    if (res && (res.sucesso || res.mensagem)) {
      // Prepara o formulário para um próximo período, sem repetir os horários que acabaram de ser criados
      ultimoExistente = new Date(dataFim + 'T12:00:00');
      inicioSugerido = new Date(ultimoExistente); inicioSugerido.setDate(inicioSugerido.getDate() + 1);
      const novoFim = new Date(inicioSugerido); novoFim.setDate(novoFim.getDate() + 60);
      dataInicio = isoData(inicioSugerido); dataFim = isoData(novoFim);
      dispatch('passoConcluido', res.mensagem);
    } else {
      dispatch('recarregar', res?.erro || 'Não foi possível criar os horários agora. Tente novamente.');
    }
  }
</script>

<section class="card-panel fade-in">
  <h2>Abrir horários</h2>
  <p class="subtitulo">Diga quando você atende e o sistema cria todos os horários de uma vez. Seus clientes só veem os horários livres.</p>

  {#if ultimoExistente}
    <div class="aviso-existente">
      <i class="fas fa-info-circle"></i>
      Você já tem horários abertos até <strong>{ultimoExistente.toLocaleDateString('pt-BR')}</strong>. Para não repetir horários, já deixamos o início em {inicioSugerido.toLocaleDateString('pt-BR')}.
    </div>
  {/if}

  <div class="form-grid">
    <div class="grid-full">
      {#if locais.length === 0}
        <label>Onde você atende?</label>
        <div class="novo-local">
          <input type="text" class="input-app" bind:value={novoLocalNome} placeholder="Ex.: Consultório Centro, Salão, Atendimento online" />
          <input type="text" class="input-app" bind:value={novoLocalEndereco} placeholder="Endereço ou link (opcional)" />
        </div>
      {:else}
        <div class="label-row">
          <label style="margin: 0;">Onde serão esses atendimentos?</label>
          <button class="link-acao" on:click={() => dispatch('mudarAba', 'locais')}><i class="fas fa-plus"></i> Novo local</button>
        </div>
        <select class="input-app" bind:value={localAtendimento}>
          <option value="">Escolha o local...</option>
          {#each locais as loc}
            <option value="{loc.nome}|{loc.endereco || ''}">{loc.nome}</option>
          {/each}
        </select>
      {/if}
      {#if erros.local}<p class="erro">{erros.local}</p>{/if}
    </div>

    <div><label>De</label><input type="date" class="input-app" bind:value={dataInicio} min={isoData(hoje)} /></div>
    <div><label>Até</label><input type="date" class="input-app" bind:value={dataFim} min={dataInicio} /></div>
    {#if erros.datas}<p class="erro grid-full">{erros.datas}</p>{/if}

    <div class="grid-full">
      <label>Dias da semana</label>
      <div class="chip-group">
        {#each diasDaSemana as dia, i}
          <button class="chip {diasSelecionados.includes(i) ? 'selected' : ''}" on:click={() => handleDiaChange(i)}>{dia}</button>
        {/each}
      </div>
      {#if erros.dias}<p class="erro">{erros.dias}</p>{/if}
    </div>

    <div class="grid-full">
      <div class="radio-toggle">
        <button class:active={modo === 'expediente'} on:click={() => modo = 'expediente'}>Meu expediente</button>
        <button class:active={modo === 'avulsos'} on:click={() => modo = 'avulsos'}>Horários específicos</button>
      </div>
    </div>

    {#if modo === 'expediente'}
      <div><label>Começo às</label><input type="time" class="input-app" bind:value={inicioExpediente} /></div>
      <div><label>Termino às</label><input type="time" class="input-app" bind:value={fimExpediente} /></div>
      <div>
        <label>Cada atendimento dura</label>
        <select class="input-app" bind:value={duracao}>
          {#each duracoes as d}<option value={d}>{rotuloDuracao(d)}</option>{/each}
        </select>
      </div>
      <div>
        <label class="check-label"><input type="checkbox" bind:checked={temIntervalo} /> Tenho intervalo (almoço)</label>
        {#if temIntervalo}
          <div class="intervalo">
            <input type="time" class="input-app" bind:value={inicioIntervalo} />
            <span>às</span>
            <input type="time" class="input-app" bind:value={fimIntervalo} />
          </div>
        {/if}
      </div>
    {:else}
      <div class="grid-full">
        <label>Horários de início</label>
        {#each horariosInicio as h, i}
          <div class="row-time">
            <input type="time" class="input-app" bind:value={h.hora} />
            {#if i > 0} <button class="btn-del" on:click={() => horariosInicio = horariosInicio.filter((_, idx) => idx !== i)}><i class="fas fa-trash"></i></button> {/if}
          </div>
        {/each}
        <button class="btn-add" on:click={() => horariosInicio = [...horariosInicio, { hora: '' }]}><i class="fas fa-plus"></i> Adicionar horário</button>
        <div style="max-width: 260px; margin-top: 10px;">
          <label>Cada atendimento dura</label>
          <select class="input-app" bind:value={duracao}>
            {#each duracoes as d}<option value={d}>{rotuloDuracao(d)}</option>{/each}
          </select>
        </div>
      </div>
    {/if}
    {#if erros.horarios}<p class="erro grid-full">{erros.horarios}</p>{/if}

    {#if listaFinal.length > 0}
      <div class="grid-full previa">
        <strong>Horários de cada dia:</strong>
        <div class="previa-lista">{#each listaFinal as h}<span>{h}</span>{/each}</div>
        {#if totalEstimado > 0}<small>Serão criados cerca de <strong>{totalEstimado}</strong> horários no período escolhido.</small>{/if}
      </div>
    {/if}

    <div class="grid-full">
      <button class="btn-primary" on:click={criarHorarios}><i class="fas fa-check"></i> Abrir estes horários</button>
    </div>
  </div>
</section>

<style>
  .subtitulo { margin: -12px 0 22px 0; color: #5a7063; font-size: 0.92rem; line-height: 1.5; }
  .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
  .grid-full { grid-column: 1 / -1; }
  .label-row { display: flex; justify-content: space-between; align-items: end; margin-bottom: 8px; }
  .link-acao { background: none; border: none; color: var(--primary); font-weight: bold; cursor: pointer; font-size: 0.8rem; }
  .novo-local { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .radio-toggle { display: flex; background: var(--bg-app); padding: 5px; border-radius: 8px; gap: 5px; max-width: 420px; }
  .radio-toggle button { flex: 1; border: none; background: transparent; padding: 9px; border-radius: 6px; cursor: pointer; font-weight: 600; font-size: 0.85rem; transition: 0.2s; font-family: inherit; }
  .radio-toggle button.active { background: white; color: var(--primary); box-shadow: 0 2px 6px rgba(0,0,0,0.06); }
  .chip-group { display: flex; flex-wrap: wrap; gap: 8px; }
  .chip { background: var(--bg-app); border: 1px solid var(--border); padding: 6px 12px; border-radius: 20px; cursor: pointer; font-size: 0.8rem; font-weight: 600; font-family: inherit; }
  .chip.selected { background: var(--primary); color: white; border-color: var(--primary); }
  .row-time { display: flex; gap: 10px; margin-bottom: 8px; max-width: 260px; }
  .btn-add { background: none; border: none; color: var(--accent); font-weight: 700; cursor: pointer; font-size: 0.85rem; margin-top: 5px; }
  .check-label { display: flex; align-items: center; gap: 8px; cursor: pointer; }
  .check-label input { width: 16px; height: 16px; }
  .intervalo { display: flex; align-items: center; gap: 8px; }
  .intervalo span { font-size: 0.85rem; color: #5a7063; }
  .previa { background: #eef5f0; border-radius: 10px; padding: 14px 16px; font-size: 0.88rem; }
  .previa-lista { display: flex; flex-wrap: wrap; gap: 6px; margin: 8px 0; }
  .previa-lista span { background: white; border: 1px solid #c9d6cd; border-radius: 6px; padding: 3px 8px; font-weight: 700; color: var(--primary); font-size: 0.8rem; }
  .previa small { color: #5a7063; }
  .aviso-existente { background: #eef5f0; border-left: 4px solid var(--primary); border-radius: 8px; padding: 12px 14px; font-size: 0.88rem; color: #2c3e34; margin: -6px 0 20px 0; line-height: 1.5; }
  .erro { color: #c53030; font-size: 0.82rem; font-weight: 600; margin: 6px 0 0 0; }
  @media (max-width: 900px) { .form-grid { grid-template-columns: 1fr; } }
  @media (max-width: 640px) {
    .novo-local { grid-template-columns: 1fr; }
    .chip-group { gap: 6px; }
    .row-time { max-width: none; }
    .btn-add { width: 100%; text-align: left; }
  }
</style>
